/** Threat colour (L8): a foe's name by its power rank against the player's: grey much weaker, white even, yellow stronger, red much stronger. */
export const threatColor = (foe: number, player: number): string => {
  const d = foe - player;
  return d <= -4 ? '#9a948c' : d <= 1 ? '#f4efe6' : d <= 3 ? '#ffd45a' : '#ff5a5a';
};
